// PROPOSITO: mediciones y fotos de demostracion. Enseña la evolucion mes a mes.
// DEPENDENCIAS: src/types/dominio.
// NO OBVIO (1): las columnas son EXACTAMENTE las del Excel antropometrico de Flor: peso, estatura,
// IMC, % de grasa, cintura, cadera, muslo D/I, brazo D/I, mes 1 a mes 12. Ver docs/fuentes.
// NO OBVIO (2): la curva no es una linea recta hacia abajo. Hay un mes que sube y otro que se
// estanca, porque eso es lo que pasa de verdad y es justo cuando Flor tiene que intervenir. Un
// demo con progreso perfecto le enseña a Flor una app que no existe.

import type { FotoDeProgreso, Medicion } from '@/types/dominio'

const ESTATURA_CM = 158

interface Toma {
  fecha: string
  peso: number
  grasa: number
  cintura: number
  cadera: number
  musloDer: number
  musloIzq: number
  brazoDer: number
  brazoIzq: number
  nota: string | null
}

const TOMAS: Toma[] = [
  { fecha: '2026-04-06', peso: 68.4, grasa: 32.0, cintura: 82, cadera: 104, musloDer: 60, musloIzq: 59.5, brazoDer: 30.5, brazoIzq: 30, nota: 'Punto de partida' },
  { fecha: '2026-05-04', peso: 66.9, grasa: 30.8, cintura: 79.5, cadera: 103, musloDer: 59.5, musloIzq: 59, brazoDer: 30, brazoIzq: 29.5, nota: null },
  { fecha: '2026-06-01', peso: 65.7, grasa: 29.6, cintura: 77, cadera: 102, musloDer: 59, musloIzq: 58.5, brazoDer: 29.5, brazoIzq: 29.5, nota: null },
  { fecha: '2026-07-06', peso: 66.2, grasa: 29.4, cintura: 77, cadera: 102, musloDer: 59, musloIzq: 58.5, brazoDer: 29.5, brazoIzq: 29, nota: 'Dos semanas de viaje' },
  { fecha: '2026-08-03', peso: 64.8, grasa: 28.1, cintura: 75, cadera: 101, musloDer: 58.5, musloIzq: 58, brazoDer: 29, brazoIzq: 29, nota: null },
  { fecha: '2026-09-07', peso: 63.5, grasa: 27.0, cintura: 73, cadera: 100, musloDer: 58, musloIzq: 57.5, brazoDer: 28.5, brazoIzq: 28.5, nota: null },
]

function imc(pesoKg: number): number {
  return Math.round((pesoKg / (ESTATURA_CM / 100) ** 2) * 10) / 10
}

export function medicionesDeDemostracion(): Medicion[] {
  return TOMAS.map((t, i) => ({
    id: `demo-medicion-${String(i)}`,
    fecha: t.fecha,
    pesoKg: t.peso,
    imc: imc(t.peso),
    grasaPct: t.grasa,
    cinturaCm: t.cintura,
    caderaCm: t.cadera,
    musloDerCm: t.musloDer,
    musloIzqCm: t.musloIzq,
    brazoDerCm: t.brazoDer,
    brazoIzqCm: t.brazoIzq,
    registradoPor: i === 0 ? 'demo-entrenadora' : 'demo-perfil',
    nota: t.nota,
  }))
}

/** Frente, espalda y lado — los tres angulos de la guia de Flor. Solo el primer y el ultimo mes. */
export function fotosDeDemostracion(): FotoDeProgreso[] {
  const angulos = ['frente', 'espalda', 'lado'] as const
  return ['2026-09-07', '2026-04-06'].flatMap(fecha =>
    angulos.map(angulo => ({
      id: `demo-foto-${fecha}-${angulo}`,
      fecha,
      angulo,
      rutaStorage: `demo/${fecha}/${angulo}.webp`,
      visibleParaEntrenadora: true,
    })),
  )
}

export const ESTATURA_DE_DEMOSTRACION = ESTATURA_CM
